import React, { useEffect, useState } from "react"
import { Link } from "gatsby"

const STORAGE_KEY = "cookie-consent"
const GA_MEASUREMENT_ID = "G-GL0BWR0P31"

function loadGoogleAnalytics() {
  if (typeof window === "undefined") return
  if (window.__gaLoaded) return

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = gtag
  gtag("js", new Date())
  gtag("config", GA_MEASUREMENT_ID, { anonymize_ip: true })

  window.__gaLoaded = true
}

export default function CookieConsent() {
  // Start with "loading" state - don't show anything until we check localStorage
  const [status, setStatus] = useState("loading")

  useEffect(() => {
    if (typeof window === "undefined") return

    const stored = window.localStorage.getItem(STORAGE_KEY)
    
    if (stored === "granted") {
      loadGoogleAnalytics()
      setStatus("decided")
    } else if (stored === "denied") {
      setStatus("decided")
    } else {
      // No decision yet - show the banner
      setStatus("pending")
    }
  }, [])

  const accept = () => {
    if (typeof window === "undefined") return
    window.localStorage.setItem(STORAGE_KEY, "granted")
    setStatus("decided")
    loadGoogleAnalytics()
  }

  const decline = () => {
    if (typeof window === "undefined") return
    window.localStorage.setItem(STORAGE_KEY, "denied")
    setStatus("decided")
  }

  // Don't render anything while loading or after decision
  if (status !== "pending") {
    return null
  }

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie Hinweis"
      style={{ 
        position: "fixed",
        left: "16px",
        right: "16px",
        zIndex: 9999,
        pointerEvents: "auto"
      }}
      className="bottom-4 mx-auto max-w-2xl rounded-lg bg-white p-5 shadow-2xl border border-slate-200"
    >
      <div className="mb-4">
        <h3 className="text-base font-semibold text-slate-800 mb-2">
          🍪 Cookies & Analyse
        </h3>
        <p className="text-sm text-slate-600 leading-relaxed">
          Wir nutzen Google Analytics, um unsere Website zu verbessern. 
          Die Datenerfassung erfolgt nur mit Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). 
          Mehr Infos in unserer{" "}
          <Link to="/impressum" className="text-sky-600 underline hover:text-sky-700">
            Datenschutzerklärung
          </Link>
          .
        </p>
      </div>
      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          onClick={accept}
          style={{ pointerEvents: "auto", cursor: "pointer" }}
          className="rounded-md bg-sky-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-sky-600 transition-colors"
        >
          Akzeptieren
        </button>
        <button
          type="button"
          onClick={decline}
          style={{ pointerEvents: "auto", cursor: "pointer" }}
          className="rounded-md border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
        >
          Nur notwendige
        </button>
      </div>
    </div>
  )
}
